export default {
  Catalogue: 'Catalogue',
  Coupons: 'Coupons',
  DiscountClub: 'Discount Club',
  Homepage: 'Homepage',
  Offers: 'Offers',
  Other: 'Other',
  'Recommended Subscriptions': 'Recommended Subscriptions',
  Search: 'Search results',
  SearchNoResults: 'Search no results',
  Subscriptions: 'Subscriptions',
  SavingsHub: 'Savings hub',
};
